<template>
  <div :class="['text-block', alignmentClass]">
    <div v-html="text" class="rich-text content-page"></div>
    <div v-if="entryLink?.url">
        <a :href="entryLink.url" class="btn-icon-right mx-auto mt-4"></a>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

// Props
const props = defineProps({
  text: { type: String, required: true },
  alignment: { type: String, default: 'left' },
  entryLink: { type: Object, default: null }
})

// Computed class for alignment
const alignmentClass = computed(() => {
  if (props.alignment === 'center') return 'col-12 center'
  if (props.alignment === 'right') return 'col-10 offset-2 col-sm-6 offset-sm-6'
  return 'col-10 col-sm-6'
})
</script>
